import { render, staticRenderFns } from "./PrintsPage.vue?vue&type=template&id=aafff56c&scoped=true&"
import script from "./PrintsPage.vue?vue&type=script&lang=js&"
export * from "./PrintsPage.vue?vue&type=script&lang=js&"
import style0 from "./PrintsPage.vue?vue&type=style&index=0&id=aafff56c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafff56c",
  null
  
)

export default component.exports